<template>
  <div class="box">
    <div class="homepage" id="homepage">
      <div class="bannerAll">
        <img class="banner" :src='bg' />
        <div class="content1">
          <p class="header1 hidden-sm-and-down">技能开发平台</p>
          <p class="con hidden-sm-and-down">零基础快速开发语音交互技能</p>
          <!-- <router-link to='/createSkill'>-->
          <el-button class="bannerButton" type="primary" round @click="routeCreateSkill">立即创建技能 <span style="position: relative;top: -2px;">&rarr;</span>
            <i class="iconfont icon-youjiantou"></i>
          </el-button>
          <!--</router-link>-->
          <router-link to='/tutor/ptjj' class="see">
            <span>查看文档</span>
          </router-link>
        </div>
      </div>
      <div class="main1 hidden-sm-and-down">
        <div class="bg-bottom">
        <!-- <router-link to="/developer">-->
        <span class="sc1 sc" v-on:click="jump(0)"></span>
        <!-- </router-link>-->
        <!-- <router-link to="/tutorial">-->
        <span class="sc1"  v-on:click="jump(1)"></span>
        <!--  </router-link>-->
        <!-- <router-link to="/tutorial">-->
        <span class="sc1"  v-on:click="jump(2)"></span>
        <!-- </router-link>-->
        <!-- <router-link to="/createPro">-->
        <span class="sc1"  v-on:click="jump(3)"></span>
        <!-- </router-link>-->
        </div>
      </div>
      <!-- <div  class="main2 main_nav hidden-sm-and-down">
        <div class="title clearfix" v-bind:class="{nav_fixed:show_jump,jump_index:show_nav}">
          <div class="tCon">
            <div class="tLeft">
              <span class="tLogo"></span>
              <span class="tWord">开放平台</span>
            </div>
            <div class="tRight">
              <router-link to='/createSkill' class="tList">
                <span>技术教程</span>
              </router-link>
              <router-link to='/createSkill' class="tList">
                <span>技能开放平台</span>
              </router-link>

              <router-link to='/createSkill' class="tList">
                <span>控制台</span>
              </router-link>
              <router-link to='/createSkill' class="tList">
                <span>开发者认证</span>
              </router-link>
              <router-link to='/createSkill' class="tlogin">
                <span>登录</span>
              </router-link>
            </div>
          </div>
           </div>
      </div> -->
      <div>
        <div ref="nav" class="main2 d_jump hidden-sm-and-down"  v-bind:class="{jump_index:show_nav}">
          <div class="con2">
            <h3>语音技能交互链路</h3>
            <p>用户发起语音指令，开放平台对语音信号进行识别解析并将结果POST到开发者服务器，开发者针对解析结果进行相应的业务处理，调用开放平台语音合成接口，用户即可听到您的答复</p>
            <div class='contImg'>
              <img :src='cont2'>
            </div>
          </div>
        </div>
        <div class="main3 d_jump hidden-sm-and-down"  v-bind:class="{jump_index:show_nav}">
          <div class="con2">
            <h3>创建技能</h3>
            <p>用户发起语音指令，开放平台对语音信号进行识别解析并将结果POST到开发者服务器，开发者针对解析结果进行相应的业务处理，调用开放平台语音合成接口，用户即可听到您的答复</p>
            <div class="jn-list">
              <ul class="clearfix">
                <li class="list-item">
                  <h5>自定义技能</h5>
                  <div class="list-img">
                    <img :src='cont31' />
                  </div>
                  <p class="list-cont">
                    自定义技能有较强的定制化处理能力，开发者可以根据解析结果，在自己服务器开发相关逻辑
                  </p>
                  <div class="more-btn">
                    <router-link to='/tutor/zdyjn_ks' class="">
                      了解更多
                    </router-link>
                  </div>
                </li>
                <li class="list-item">
                  <h5>内容类技能</h5>
                  <div class="list-img">
                    <img :src='cont32' />
                  </div>
                  <p class="list-cont">
                    无需开发即可迅速创建技能，开发者仅需要按照指定步骤上传内容，即可完成开发
                  </p>
                  <div class="more-btn">
                    <router-link to='/tutor/ysnrjn' class="">
                      了解更多
                    </router-link>
                  </div>
                </li>
                <li class="list-item">
                  <h5>智能家居技能</h5>
                  <div class="list-img">
                    <img :src='cont33' />
                  </div>
                  <p class="list-cont">
                    为智能家居开发者提供了更加标准的开发接口，开发者仅需要少量配置和开发工作即可迅速完成技能
                  </p>
                  <div class="more-btn">
                    <router-link to='/tutor/znjjjnjs' class="">
                      了解更多
                    </router-link>
                  </div>
                </li>

              </ul>

            </div>

          </div>

        </div>
        <div class="main4 d_jump hidden-sm-and-down" v-bind:class="{jump_index:show_nav}">
          <div class="con2">
            <h3>配置技能</h3>
            <p>语音技能是语音交互的基本单元，一个语音技能的构成包含了意图，槽位，字典等核心元素。一个优秀的语音技能应当在创建初期梳理其逻辑关系</p>
          </div>
          <div class="pz-list">
            <ul class="clearfix">
              <li class="pz-item pz41">
                <div class="pz-right">
                  <div class="pz-cont">
                    <p>语音技能是一个完整的语音交互体验场景一个语音技能由多个意图组成</p>
                  </div>
                  <div class="pz-btn">
                    <router-link to='/tutor/zygn_jn' class="">
                      查看技能教程
                    </router-link>
                  </div>
                </div>
              </li>
              <li class="pz-item pz42">
                <div class="pz-right">
                  <div class="pz-cont">
                    <p>开放平台为用户提供了高频使用的意图，如取消，暂停等，用户可通过添加直接使用</p>
                  </div>
                  <div class="pz-btn">
                    <router-link to='/tutor/zygn_yt' class="">
                      查看系统意图教程
                    </router-link>
                  </div>
                </div>
              </li>
              <li class="pz-item pz43 last">
                <div class="pz-right">
                  <div class="pz-cont">
                    <p>同一领域的术语集合,如城市词典，歌手词典等。应用于用户表达信息的提取和语义槽的调用</p>
                  </div>
                  <div class="pz-btn">
                    <router-link to='/tutor/zygn_zd' class="">
                      查看词典教程
                    </router-link>
                  </div>
                </div>
              </li>
              <li class="pz-item pz44">
                <div class="pz-right">
                  <div class="pz-cont">
                    <p>用户常用表达透露的本质需求，如“今天天气怎么样”“帮我查一下天气”，意图均为“查天气”</p>
                  </div>
                  <div class="pz-btn">
                    <router-link to='/tutor/zygn_yt' class="">
                      查看意图教程
                    </router-link>
                  </div>
                </div>
              </li>
              <li class="pz-item pz45">
                <div class="pz-right">
                  <div class="pz-cont">
                    <p>描述意图的数据(键值对的集合),也是实现意图所需要的参数</p>
                  </div>
                  <div class="pz-btn">
                    <router-link to='/tutor/zygn_cw' class="">
                      查看槽位教程
                    </router-link>
                  </div>
                </div>
              </li>
              <li class="pz-item pz46 last">
                <div class="pz-right">
                  <div class="pz-cont">
                    <p>开放平台为用户提供了高频使用的词典，如城市词典，歌手词典开发者可通过添加直接使用</p>
                  </div>
                  <div class="pz-btn">
                    <router-link to='/tutor/zygn_zd' class="">
                      查看系统词典教程
                    </router-link>
                  </div>
                </div>
              </li>




            </ul>

          </div>



        </div>
        <div class="main5 d_jump hidden-sm-and-down" v-bind:class="{jump_index:show_nav}">
          <div class="con2">
            <h3>发布技能</h3>
            <p>技能通过测试发布上线后，终端设备可通过技能<br>商店添加您的技能</p>
            <div class='contImg'>
              <img :src='cont5'>
            </div>
          </div>
        </div>
      </div>
      <div class="fx" v-show="show_jump">
        <div class="fx-line"></div>
        <ul>
          <li v-bind:class="{active:jumpID==0}" v-on:click="jump(0)">学习</li>
          <li v-bind:class="{active:jumpID==1}" v-on:click="jump(1)">创建</li>
          <li v-bind:class="{active:jumpID==2}" v-on:click="jump(2)">配置</li>
          <li v-bind:class="{active:jumpID==3}" v-on:click="jump(3)">发布</li>
        </ul>
      </div>
      <footer>
        <div class="footer">
          <p style="clear: both;margin-bottom: 7px"><span class="pull-left">邮箱: bd@ainirobot.com&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;  地址: 北京朝阳区三里屯盈科中心C座三层</span> <span class="pull-right">技能开发QQ群:702087131</span></p>
          <p style="clear: both"><span class="pull-left">京ICP备17016764号-1&nbsp;&copy;<span>{{ new Date().getFullYear()-1 }}</span>-<span>{{ new Date().getFullYear() }}</span>&nbsp;&nbsp;&nbsp;&nbsp;猎户星空版权所有</span><span class="pull-right">硬件接入QQ群:702108481</span></p>
        </div>
      </footer>
    </div>
  </div>

</template>
<script>
export default {
  data() {
    return {
      bg: require("../../../static/images/bg.jpg"),
      jumpID: 0,
      show_jump: false,
      show_nav: false,
      jump_value: 100,
      show0: true,
      show1: false,
      show2: false,
      show3: false,
      show4: false,
      show5: false,
      scene1: require("../../../static/images/yinxiang.jpg"),
      scene2: require("../../../static/images/tv.jpg"),
      scene3: require("../../../static/images/jiaju.jpg"),
      case2: require("../../../static/images/case2.png"),
      case3: require("../../../static/images/case3.png"),
      case4: require("../../../static/images/case4.png"),
      case1: require("../../../static/images/case1.png"),
      case2: require("../../../static/images/case2.png"),
      case3: require("../../../static/images/case3.png"),
      case4: require("../../../static/images/case4.png"),
      cont2: require("../../../static/images/cont2.png"),
      cont3: require("../../../static/images/cont3.png"),
      cont31: require("../../../static/images/cont31.png"),
      cont32: require("../../../static/images/cont32.png"),
      cont33: require("../../../static/images/cont33.png"),
      cont5: require("../../../static/images/cont5.png")
    };
  },
  mounted() {
    this.reloadSee();
    $('.box').on("scroll", this.onScroll);
    this.setWidth();
  },
  methods: {
    setWidth(){
      let _body = $('#app').width();
      let _header = $('#homepage').width();
      let _w = Number(_body) - Number(_header)
//      console.log(_w);
      $('#header').css('paddingRight',_w);
    },
    getCookie(name) {
        if (document.location.host == 'opentw.ainirobot.com') {
            name = name + '_tw'
        }
        let arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)")
        if(arr=document.cookie.match(reg)) {
            return arr[2]
        } else {
            return null;
        }
    },
    routeCreateSkill () {
      //console.log(this.isPass);
      this.$store.dispatch('changeWhere','skill');
      let phone = this.getCookie('userTel');
//        console.log("我的手机号码是："+phone)
      if(phone == ""){
        this.$router.push('/login');
      }else{
        // 立即接入创建技能
        this.$router.push('/createSkill')
      }
    },
    reloadSee(){
      let st = $('.box').scrollTop();
      if($('.box').scrollTop()<720){
        $('.fx').stop().fadeOut(100);
      }else{
        $('.fx').stop().fadeIn(100);
      }

      if($('.box').scrollTop()<780){
        this.$store.dispatch('changeF')
      }else{
        this.$store.dispatch('changeT')
      }
    },
    onScroll(e) {
      let ele = document.getElementsByClassName('box')[0];
      let scrolled = ele.scrollTop;
      let jump = document.querySelectorAll(".d_jump");
      var yuzhi = 90;

      if (scrolled > this.jump_value - yuzhi) {
        this.show_nav = true;
      } else {
        this.show_nav = false;
      }
      // if (scrolled > this.jump_value) {
      // } else {
      //   this.show_jump = false;
      // }
      for (var i = 0; i < jump.length; i++) {
        let _one = jump[i],
          _offset = _one.offsetTop;
        if (
          scrolled > _offset - yuzhi &&
          scrolled < _offset + _one.clientHeight
        ) {
          // if (jump[i + 1]) {
            this.jumpID = i;
          // } else {
          //   this.jumpID = jump.length - 1;
          // }
        }
      }
      if($('.box').scrollTop()<768){
          this.$store.dispatch('changeF');
           this.show_jump = false;
        }else{
          this.$store.dispatch('changeT');

        this.show_jump = true;


        }
    },
    jump(index) {
      let jump = document.querySelectorAll(".d_jump");
      this.jumpID = index;
      // 获取需要滚动的距离
      let total = jump[index].offsetTop - 59;
      //当前滚动条位置
      let ele = document.getElementsByClassName('box')[0];
      let distance = ele.scrollTop;
      // 平滑滚动，时长500ms，每10ms一跳，共50跳
      let step = (total - distance) / 50;
      moveSmooth();

      function moveSmooth() {
        if (Math.abs(total - distance) > Math.abs(step)) {
          distance += step;
          ele.scrollTop = distance;
          ele.scrollTop = distance;
          setTimeout(moveSmooth, 10);
        } else {
          ele.scrollTop = total;
          ele.scrollTop = total;
        }
      }
    },
    enter(index) {
      // console.log('111111')
      for (let i = 0; i < 5; i++) {
        this["show" + i] = false;
        this["show" + index] = true;
        this.$refs["show" + i].classList.remove("active");
      }
    },
    leave(index) {
      this.$refs["show" + index].classList.add("active");
    }
  }
};
</script>
<style rel="stylesheet/scss" lang="scss">
  .box{
    height: 100%;
    overflow-y: auto;
  }
.homepage {
  padding: 0;
  padding-top:60px;
  position: relative;
  .jump_index {
    position: relative;
    // z-index: 22;
  }
  div {
    font-size: 14px;
  }
  .bannerAll {
    padding: 0px;
    position: relative;
    height: 620px;
    .banner {
      position: relative;
      z-index: 10;
      width: 100%;
      height: 620px;
    }
    .content1 {
      position: relative;
      text-align: center;
      top: -550px;
      z-index: 20;
      color: #fff;
      font-weight: 300;
      .header1 {
        font-size: 60px;
        margin-top: 111px;
        font-weight: 500;
      }
      .con {
        font-size: 28px;
        line-height: 14px;
        text-align: center;
        color: #fff;
        font-weight: 100;
        margin-bottom: 80px;
      }
      .see {
        font-size: 16px;
        color: #ffffff;
        margin-top: 22px;
        display: block;
        width: 64px;
        margin: 22px auto 0;
      }
      .bannerButton {
        // margin-top:80px;
        // transform: scale(1.2);
        text-align: center;
        width: 280px;
        padding: 0px;
        border-radius: 31px;
        line-height: 62px;
        overflow: hidden;
        font-size: 22px;
      }
      .icon-youjiantou {
        position: relative;
        margin: 0px;
        margin-left: 5px;
        padding: 0px;
        font-size: 22px;
      }
    }
  }
  .con2 {
    text-align: center;
    h3 {
      font-size: 30px;
      margin-top: 60px;
      font-weight: normal;
    }
    p {
      font-size: 16px;
      width: 900px;
      color: #15181a;
      margin: 20px auto 100px;
    }
  }
  .main1 {
    background: #000;
    .bg-bottom {
      background: url("../../../static/images/hard/banner-bottom.png") center;
      background-color: #000;
      width: 1022px;
      height: 60px;
      margin: 0 auto;
      overflow: hidden;
      .sc{
        margin-left: 290px;
      }
      .sc1{
        width: 180px;
        display: inline-block;
        height: 60px;
        cursor: pointer;
        float: left;
      }
    }
    .skill {
      font-size: 76px;
      color: #b9bbbf;
      display: flex;
      justify-content: center;
      transition: all 1s;
      &:hover {
        transform: rotate(180deg);
      }
    }
    .skillText {
      font-size: 18px;
      display: flex;
      justify-content: center;
      color: #43537b;
    }
    .triangle {
      position: relative;
      top: -60px;
      right: -170px;
      display: inline-block;
    }
    .triangle1 {
      opacity: 0;
    }
  }
  .main_nav {
    height: 60px;
  }
  .main2 {
    overflow: hidden;
    background: #fff;
    .con2 {
      width: 998px;
      margin: 0 auto;
    }
    .title {
      height: 60px;
      overflow: hidden;
      border-bottom: 1px solid #e5e5e5;
      background: #fff;
    }
    .tCon {
      width: 998px;
      margin: 0 auto;
      height: 60px;
      .tLeft {
        float: left;
        .tLogo {
          height: 60px;
          width: 113px;
          float: left;
          background-image: url(../../../static/images/oslogo.png);
        }
        .tWord {
          line-height: 60px;
          vertical-align: middle;
          padding-left: 10px;
          font-size: 18px;
          display: inline-block;
          float: left;
        }
      }
      .tRight {
        float: right;
        .tlogin {
          color: #aaaaaa;
          margin-left: 50px;
        }

        .tList {
          line-height: 60px;
          color: #aaaaaa;
          margin: 0 20px;
          position: relative;
          &:before {
            content: "";
            position: absolute;
            left: -20px;
            top: 2px;
            width: 1px;
            height: 14px;
            background: #d1d1d1;
          }
          &:first-child {
            &:before {
              width: 0px;
            }
          }
        }
      }
    }
    .contImg {
      margin-bottom: 130px;
    }
  }
  .main3 {
    background: #f8f8f8;
    overflow: hidden;
    .jn-list {
      width: 894px;
      margin: 0 auto 112px;
      .list-item {
        float: left;
        width: 258px;
        list-style-type: none;
        margin-right: 60px;
        height: 364px;
        background: url(../../../static/images/cont3.png) no-repeat;
        &:last-child {
          margin-right: 0px;
        }
      }
      h5 {
        line-height: 67px;
        text-align: center;
        color: #ffffff;
        font-size: 20px;
        font-weight: normal;
        margin: 0px;
        padding: 0px;
      }
      .list-img {
        margin: 34px auto;
      }
      .list-cont {
        font-size: 14px;
        line-height: 21px;
        width: 210px;
        height: 63px;
        margin: 0 auto 42px;
      }
      .more-btn {
        line-height: 30px;
        width: 138px;
        margin: 0 auto;
        border: 1px solid #0092df;
        text-align: center;
        border-radius: 15px;
      }
    }
  }
  .main4 {
    background: #fff;
    overflow: hidden;
    .pz-list {
      width: 1000px;
      margin: 0 auto;
    }
    .pz-item {
      width: 301px;
      height: 170px;
      margin-right: 44px;
      padding-left: 55px;
      margin-bottom: 44px;
      list-style-type: none;
      overflow: hidden;
      position: relative;
      float: left;
      &.last {
        margin-right: 0px;
      }
      .pz-cont {
        width: 196px;
        margin: 20px auto 0;
        font-size: 14px;
      }
      .pz-btn {
        position: absolute;
        right: 25px;
        bottom: 16px;
        border: 1px solid #0092df;

        width: 116px;
        line-height: 30px;
        text-align: center;
        border-radius: 15px;
        a {
          color: #0092df;
          font-size: 12px;
        }
      }
    }
    .pz41 {
      background: url(../../../static/images/41.png) no-repeat;
    }
    .pz42 {
      background: url(../../../static/images/42.png) no-repeat;
    }
    .pz43 {
      background: url(../../../static/images/43.png) no-repeat;
    }
    .pz44 {
      background: url(../../../static/images/44.png) no-repeat;
    }
    .pz45 {
      background: url(../../../static/images/45.png) no-repeat;
    }
    .pz46 {
      background: url(../../../static/images/46.png) no-repeat;
    }
  }
  .main5 {
    background: #f8f8f8;
    overflow: hidden;
  }
  // .nav_fixed {
  //   position: fixed;
  //   top: 0;
  //   width: 100%;
  //   z-index: 24;
  // }
  .fx {
    position: fixed;
    height: 166px;
    top: 280px;
    right: 120px;
    z-index: 25;
    .fx-line {
      width: 1px;
      background-color: #e0e0e0;
      height: 166px;
    }
    ul {
      position: absolute;
      top: 0px;
      left: 0px;
      li {
        list-style-type: none;
        width: 40px;
        line-height: 42px;
        height: 42px;
        padding-left: 5px;
        &.active {
          border-left: 1px solid #077eec;
        }
      }
    }
  }
  footer{
    width: 100%;
    height: 95px;
    background: #191919;
    .footer{
      width: 1150px;
      margin: 0 auto;
      color: #79878a;
      font-size: 12px;
      padding-top: 30px;
      p{
        overflow: hidden;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/setting/HomePage.vue